export default __webpack_public_path__ + "img/appointment-link.fd49dbd2.svg";